import type { Tour } from '../tour-types';

/**
 * Settings, Agent access (PER-328): the caller's own tokens, the button that makes one (the form is
 * in a dialog, which a step cannot point into), the apps connected over OAuth (PER-334, since version
 * 2), and, for an Owner or Admin, every token in the organization. The team list only renders for
 * someone who may manage the team, so its step drops out for everyone else.
 */
export const settingsAgentAccessTour: Tour = {
  key: 'settings.agent-access',
  version: 2,
  routes: ['/settings/agent-access'],
  steps: [
    {
      anchor: 'settings-agent-access-tokens',
      placement: 'bottom',
      title: 'Your tokens',
      body: 'What each token may do and where, when it was last used and when it expires. Revoke one you no longer need and it stops working at once.',
    },
    {
      anchor: 'settings-agent-access-create',
      placement: 'bottom',
      title: 'Make a token',
      body: 'A token lets an AI agent work in Pertento as you, with only the scopes and websites you tick. It is shown once, so copy it into the agent when the dialog gives it to you.',
    },
    {
      anchor: 'settings-agent-access-apps',
      placement: 'top',
      since: 2,
      title: 'Connected apps',
      body: 'Apps you allowed to work as you, such as Claude or ChatGPT added as a connector. Disconnect one and it stops working at once.',
    },
    {
      anchor: 'settings-agent-access-team',
      placement: 'top',
      requires: 'team:manage',
      title: "Your team's tokens",
      body: 'Every token made by someone in this organization. Revoke any of them if an agent should no longer have access.',
    },
  ],
};
